// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ce4a6a9","239":"d9e023da","667":"dfdd97c5"}[chunkId] + ".chunk.js";
};